exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheatSheetPlayer-module__wrapper___1HZDi{display:grid;gap:6px;grid-template-columns:auto 1fr;justify-content:start}.CheatSheetPlayer-module__wrapper___1HZDi.CheatSheetPlayer-module__disabled___1lPi0{pointer-events:none;opacity:.5}.CheatSheetPlayer-module__wrapper___1HZDi .CheatSheetPlayer-module__right___3rjVj{min-height:35px;width:100%;border-radius:18px;background-color:#fff;display:flex;align-items:center;padding:5px 10px;color:#1368e5;display:grid;grid-template-columns:1fr auto;gap:10px;cursor:pointer}.CheatSheetPlayer-module__wrapper___1HZDi .CheatSheetPlayer-module__right___3rjVj p{width:100%;font-weight:600}.CheatSheetPlayer-module__wrapper___1HZDi .CheatSheetPlayer-module__right___3rjVj svg{font-size:12px}", ""]);

// exports
exports.locals = {
	"wrapper": "CheatSheetPlayer-module__wrapper___1HZDi",
	"disabled": "CheatSheetPlayer-module__disabled___1lPi0",
	"right": "CheatSheetPlayer-module__right___3rjVj"
};